/** Solo valores; las etiquetas vienen de i18n (`appointmentsModule.status.*`). */
export const STATUS_OPTIONS = [
  { value: "pending", tKey: "pending" },
  { value: "confirmed", tKey: "confirmed" },
  { value: "in_progress", tKey: "in_progress" },
  { value: "completed", tKey: "completed" },
  { value: "cancelled", tKey: "cancelled" },
  { value: "no_show", tKey: "no_show" },
  { value: "rescheduled", tKey: "rescheduled" },
];
